import { useTranslation } from 'react-i18next';
import type { ObjectCustomerType } from '@econtractor/types';

interface NewObjectCustomerPreviewProps {
    customer?: ObjectCustomerType;
}

const NewObjectCustomerPreview = ({ customer }: NewObjectCustomerPreviewProps) => {
    const { t } = useTranslation(['Objects']);
    const fullName = customer?.fullName?.trim() || '';
    const edrpouOrIpn = customer?.edrpouOrIpn?.trim() || '';

    if (!fullName && !edrpouOrIpn) return null;

    return (
        <div className="mb-3">
            <label className="form-label text-muted">{t('infoItems.objectCustomer')}</label>
            <div className="spec-field-value mb-0 small bg-light p-2 rounded border">
                <div className="fw-medium text-break">{fullName || '-'}</div>
                {edrpouOrIpn ? <div className="text-muted">{edrpouOrIpn}</div> : null}
            </div>
        </div>
    );
};

export default NewObjectCustomerPreview;
